import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const PROACTIVE_AI_CONTAINER_Z_INDEX = 96;

function AIContainerComponent({
	shouldFitContainer,
	zIndex,
	children,
	testId,
}: {
	shouldFitContainer: boolean;
	zIndex?: number;
	children: React.ReactNode;
	testId?: string;
}): React.JSX.Element {
	return (
		<Box
			testId={testId}
			xcss={[aiContainerStyles, shouldFitContainer && aiContainerStylesFitContainer]}
			// eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
			style={
				zIndex
					? {
							zIndex,
						}
					: undefined
			}
		>
			{children}
		</Box>
	);
}

const aiContainerStyles = xcss({
	display: 'flex',
	position: 'relative',
	// @ts-expect-error -- Using border width as these padding are used create an illusion of border required by the gradient animation
	padding: token('border.width'),
	width: 'fit-content',
	// @ts-expect-error -- setting zIndex to a constant
	zIndex: PROACTIVE_AI_CONTAINER_Z_INDEX,
});

const aiContainerStylesFitContainer = xcss({
	width: 'auto',
});

export default AIContainerComponent;
